/**
 * 从 src/locales/modules/<功能模块>/<locale>.json 合并主包文案（按目录拆分，不再使用根目录单文件大 JSON）
 */
export type MainLocaleType = 'zh-CN' | 'zh-TW' | 'en-US' | 'ja-JP'

const moduleContext = require.context('./modules', true, /^\.\/[^/]+\/(zh-CN|en-US|ja-JP|zh-TW)\.json$/)

export function loadMainLocaleMessages (locale: MainLocaleType): Record<string, unknown> {
  const suffix = `/${locale}.json`
  const messages: Record<string, unknown> = {}
  moduleContext.keys().forEach((key) => {
    if (!key.endsWith(suffix)) return
    const chunk = moduleContext(key) as Record<string, unknown>
    Object.assign(messages, chunk)
  })
  return messages
}
